import { userStatusLabel, normalizeUserStatus } from "../../helpers/userStatusHelper";

export function getClientDisplayName(raw = {}) {
  const company =
    raw.client?.companyInformation?.tradingName ||
    raw.client?.companyInformation?.registeredCompanyName ||
    "";
  if (String(company).trim()) return String(company).trim();

  const fullName = String(raw.fullName || "").trim();
  if (fullName) return fullName;

  const primary = raw.client?.primaryInformation?.fullName;
  if (String(primary || "").trim()) return String(primary).trim();

  return "";
}

export function getClientDashboardStatus(raw = {}) {
  const accountStatus = normalizeUserStatus(raw.status);
  const isBlocked = !!raw.isBlockedByAdmin;
  const isApproved = accountStatus === "approved";
  const isActionRequired = accountStatus === "actionRequired";
  const isActive = isApproved && !isBlocked;

  return {
    accountStatus,
    statusLabel: userStatusLabel(accountStatus),
    isActive,
    isApproved,
    isBlocked,
    isActionRequired,
  };
}

export function getClientCompanySummary(raw = {}) {
  const ci = raw.client?.companyInformation ?? {};
  const pi = raw.client?.primaryInformation ?? {};

  return {
    registeredCompanyName: ci.registeredCompanyName || "",
    tradingName: ci.tradingName || "",
    companyRegistrationNumber: ci.companyRegistrationNumber || "",
    industrySector: ci.industrySector || "",
    primaryContact: raw.fullName || pi.fullName || "",
    email: raw.email || "",
    position: pi.position || "",
    photo: raw.photo || "",
  };
}

export function extractClientBookingsList(response) {
  const responsePayload = response ?? {};
  const nestedPayload = responsePayload?.data ?? responsePayload;

  if (Array.isArray(nestedPayload)) return nestedPayload;
  if (Array.isArray(nestedPayload?.data)) return nestedPayload.data;
  if (Array.isArray(nestedPayload?.bookings)) return nestedPayload.bookings;
  return [];
}
